import { render, staticRenderFns } from "./parentInventory.vue?vue&type=template&id=9ae813c8&scoped=true"
import script from "./parentInventory.vue?vue&type=script&lang=js"
export * from "./parentInventory.vue?vue&type=script&lang=js"
import style0 from "./parentInventory.vue?vue&type=style&index=0&id=9ae813c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae813c8",
  null
  
)

export default component.exports